import { Modal } from 'bootstrap';

export default class PickerManager {

    
    // Initialisiert die Klasse
    constructor() {
        this.apiBaseUrl = '/api/warehouse_new';
    }


    // 	Holt Cookie-Werte
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }


    // 	Fügt neue Lagerplatz-Zeile hinzu
    addLocationRow(tbody, options, selId = null, qty = 0, batchId = null) {
        const tr = document.createElement('tr');
        tr.innerHTML = '<td></td><td></td><td></td><td></td>';


        // Lagerplatz Select
        const select = document.createElement('select');
        select.className = 'form-select form-select-sm';
        options.forEach(o =>
            select.add(new Option(o.storage_location_name, o.storage_location_id, false, o.storage_location_id === selId))
        );

        // Chargen Select  
        const batchSelect = document.createElement('select');
        batchSelect.className = 'form-select form-select-sm';
        batchSelect.add(new Option('Keine Charge', '', false, batchId === null));
        options.forEach(o => {
            if (o.batch_number) {
                batchSelect.add(new Option(o.batch_number, o.batch_number_id, false, o.batch_number_id === batchId));
            }
        });

        // Menge Input
        const input = document.createElement('input');
        input.type = 'number'; input.min = 0; input.step = '0.01';
        input.className = 'form-control form-control-sm'; input.value = qty;

        // Löschen Button
        const delBtn = document.createElement('button');
        delBtn.type = 'button'; delBtn.className = 'btn btn-link btn-sm text-danger';
        delBtn.innerHTML = '&times;'; delBtn.onclick = () => tr.remove();

        tr.children[0].appendChild(select);
        tr.children[1].appendChild(batchSelect);
        tr.children[2].appendChild(input);
        tr.children[3].appendChild(delBtn);
        tbody.appendChild(tr);
    }


    // Öffnet Modal für PickLine-Details
    async openPickModal(pickLineId) {
        const pickRes = await fetch(`${this.apiBaseUrl}/picklines/${pickLineId}/`);
        const storageRes = await fetch(`${this.apiBaseUrl}/picklines/${pickLineId}/available_stock/`);
        if (!pickRes.ok || !storageRes.ok) throw new Error();

        const pickLine = await pickRes.json();
        const storageOptions = await storageRes.json();

        const modalEl = document.getElementById('pickInfoModal');
        const modal = new Modal(modalEl);

        const tbody = modalEl.querySelector('#pm-location-table tbody');
        modalEl.querySelector('#pm-product').innerText = `${pickLine.product_name}`;
        modalEl.querySelector('#pm-target').innerText = pickLine.quantity_target;
        modalEl.querySelector('#pm-picked').innerText = pickLine.quantity_picked || '0.00';

        tbody.innerHTML = '';
        pickLine.locations.forEach(location =>
            this.addLocationRow(
                tbody, 
                storageOptions, 
                location.storage_location.id, 
                location.quantity,
                location.batch_number_id) 
        );

        modalEl.querySelector('#pm-add-location')
            .onclick = () => this.addLocationRow(tbody, storageOptions);

        modalEl.querySelector('#pickForm').onsubmit = async e => {
            e.preventDefault();
            
            const payload = [...tbody.querySelectorAll('tr')].map(tr => ({
                storage_location: +tr.querySelector('select').value,
                quantity: +tr.querySelector('input').value
            }));    

            try {
                const res = await fetch(`${this.apiBaseUrl}/picklines/${pickLineId}/update_locations/`, {
                    method: 'PATCH',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${this.getCookie('drfToken')}`
                    },
                    credentials: 'include',
                    body: JSON.stringify({ locations: payload })
                });
                if (!res.ok) throw new Error(await res.text());

                if (typeof pickType !== 'undefined' && typeof pickDoc !== 'undefined' && typeof pickContainerId !== 'undefined') {
                    await this.renderPickTable(pickType, pickContainerId, pickDoc);
                } 
                modal.hide();
            } catch (err) {
                console.error(err);
            }
        };

        modal.show();
    }



    // Lädt Pick-Daten von der API
    async fetchPickData(document_type, documentId) {
        try {
            const response = await fetch(`${this.apiBaseUrl}/pickorders/${document_type}/${documentId}/`);
            if (!response.ok) {
                throw new Error(`Fetch error: ${response.status}`);
            }
            const picks = await response.json();

            const items = picks.flatMap(pick =>
                pick.lines.map(line => {
                    const pickLineId = line.id;   
                    const productName = line.product_name;
                    const quantity = line.quantity_target;
                    const quantity_picked = line.quantity_picked || '0.00';
                    const storageLocation = line.locations[0]?.storage_location?.name || 'kein Lagerplatz';
                    const batchNumber = line.locations[0]?.batch_number || null;
                    const pick_order_pk = pick.id;    
                    const order_status = pick.confirmed_at ? 'BESTÄTIGT' : 'OFFEN';   
                    return { pickLineId, productName, quantity, storageLocation, quantity_picked, pick_order_pk, order_status, batchNumber};
                })
            );
            return items;
        } catch (error) {
            console.error('Fehler beim Laden der Picks:', error);
            return [];
        }
    }


    // Rendert die Pick-Tabelle
    async renderPickTable(document_type, containerId, documentId) {
        const container = document.getElementById(containerId);
        if (!container) {
            console.error(`Container mit ID "${containerId}" nicht gefunden.`);
            return;
        }

        const data = await this.fetchPickData(document_type, documentId);
        const pickOrderPk = data.find(d => d.pick_order_pk)?.pick_order_pk ?? null;

        const pickStatus = data.find(d => d.order_status)?.order_status ?? 'OFFEN';
        const isConfirmed = pickStatus === 'BESTÄTIGT'; 

        let tableHtml = `
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Produktname</th>
                        <th>Soll-Menge</th>
                        <th>Ist-Menge gesamt</th>
                        <th>Lagerplatz</th>
                        <th>Chargennummer</th>
                    </tr>
                </thead>
                <tbody>
        `;

        data.forEach(item => {
            tableHtml += `
                <tr data-id="${item.pickLineId}" style="cursor:pointer">
                    <td>${item.productName}</td>
                    <td>${item.quantity}</td>
                    <td>${item.quantity_picked}</td>
                    <td>${item.storageLocation}</td>
                    <td>${item.batchNumber || '-'}</td>
                </tr>
            `;
        });

        tableHtml += `
                </tbody>
            </table>
        `;

        tableHtml += `
            <div class="text-end mt-2">
                <button id="btn-complete"
                        class="btn btn-primary btn-sm"
                        data-type="${document_type}"
                        data-doc="${documentId}"
                        data-pk="${pickOrderPk}" ${isConfirmed ? 'disabled' : ''}>
                    Pickauftrag abschließen
                </button>
            </div>`;

        container.innerHTML = tableHtml;
        container.querySelector('tbody').addEventListener('click', event => {
            const row = event.target.closest('tr[data-id]');
            if (row) {
                const id = +row.dataset.id;
                if (id) this.openPickModal(id);
            }
        });

        const btn = document.getElementById('btn-complete');
        const allPicked = data.every(item => parseFloat(item.quantity_picked) >= parseFloat(item.quantity));
        btn.disabled = !allPicked || isConfirmed;

        btn.onclick = async () => {
            if (btn.disabled) return;
            const { type, doc, pk } = btn.dataset;
            const url = `${this.apiBaseUrl}/pickorders/${type}/${doc}/${pk}/complete/`;
            const res = await fetch(url, { 
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${this.getCookie('drfToken')}`
                },
                credentials: 'include'
            });

            if (res.ok) {
                if (typeof pickType !== 'undefined' && typeof pickDoc !== 'undefined' && typeof pickContainerId !== 'undefined') {
                    await this.renderPickTable(pickType, pickContainerId, pickDoc);
                } 
            } else {
                console.error(await res.text());
            }
        };
    }
}